var mapAssignmentKeyToParties = function mapAssignmentKeyToParties(assignmentKey, mappings) {
  if (!assignmentKey || !mappings) return [];
  return mappings.filter(function (mapping) {
    return mapping.assignmentKey === assignmentKey;
  });
};

var mapAssignmentKeyAndNameToParties = function mapAssignmentKeyAndNameToParties(assignmentKey, name, mappings) {
  if (!name) return mapAssignmentKeyToParties(assignmentKey, mappings);
  var filteredMappings = mappings === null || mappings === void 0 ? void 0 : mappings.filter(function (mapping) {
    return mapping.assignmentKey === assignmentKey && mapping.name === name;
  });
  return filteredMappings !== null && filteredMappings !== void 0 ? filteredMappings : [];
};

var getDefaultPartiesForAssignmentKey = function getDefaultPartiesForAssignmentKey(assignmentKey, mappings) {
  var mappingsForAssignmentKey = mapAssignmentKeyToParties(assignmentKey, mappings);
  var groupedMappings = mappingsForAssignmentKey.filter(function (mapping) {
    return mapping.group;
  });
  return groupedMappings.length ? [groupedMappings[0]] : mappingsForAssignmentKey;
};

export { getDefaultPartiesForAssignmentKey, mapAssignmentKeyAndNameToParties, mapAssignmentKeyToParties };